

import React, { useState, useRef, useEffect } from "react";
import { Button, Form, Input, Alert,Row,Col } from "antd";
import "antd/dist/antd.css";


type SubHeaderProps={
text:String
}

function SubHeaderText(props:SubHeaderProps) {
  const{text}=props

  return (

        
<text className="subHeader_text">{text}</text>
 
  );
}

export default SubHeaderText;
